module.exports = __webpack_public_path__ + "static/media/Speed-rating-value.54673a85.svg";